/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Research_LinkInputs */

const en_cap_research_link = /** @type {(inputs: Cap_Research_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the content engine case study`)
};

const lv_cap_research_link = /** @type {(inputs: Cap_Research_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasīt par satura sistēmu`)
};

/**
* | output |
* | --- |
* | "Read the content engine case study" |
*
* @param {Cap_Research_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_research_link = /** @type {((inputs?: Cap_Research_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Research_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_research_link(inputs)
	return en_cap_research_link(inputs)
});